import { ConfigVisualisation } from '@/types/visualisation';

export const getVisualisationsForMetric = (allVisualisations: ConfigVisualisation[], selectedMetric: string) => {
  const universalVisualisations = allVisualisations.filter(({ universal }) => universal);
  const metricSpecificVisualisations = allVisualisations.filter(({ visualisationMetrics }) =>
    visualisationMetrics.some(({ metricKey }) => metricKey === selectedMetric),
  );
  return [...metricSpecificVisualisations, ...universalVisualisations].sort((a, b) => b.priority - a.priority);
};
